<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g stroke="currentColor" stroke-linecap="round" stroke-width="2"><path d="M7.999 2.5v11" fill="currentColor"/><path d="M13.5 8h-11" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-add',
});
</script>
